import Header from "./components/Header";
import InputQR from "./components/InputQR";

export default function App() {
  return (
    <main className="App">
      <Header />
      <InputQR />
    </main>
  );
}
